module.exports = __webpack_public_path__ + "static/media/iphone_app_development.2229da18.svg";